import styled from "styled-components";

export const MobileHeader = styled.div`
  width: 100%;
  height: 2.5rem;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  padding-left: 4%;
  background-color: lightgray;
`;
